class AutoRecommendations extends HTMLElement {
  constructor() {
    super();
    // Only fetch recommendations if there's a valid product ID
    this.loadingContainer = this.querySelector('.recommendations-loading-container');
    // if (!this.hasAttribute('loaded') && !this.dataset.url.includes('product_id=0')) {
    if (!this.dataset.url.includes('product_id=0')) {
      this.fetchRecommendations();
    } else if (this.dataset.url.includes('product_id=0')) {
      document.querySelector('.cart-recommendations__wrapper').style.display = 'none';
      this.loadingContainer.style.display = 'none';
    }
  }

  fetchRecommendations() {
    fetch(this.dataset.url)
      .then((response) => response.json())
      .then((data) => {
        if (data.products && data.products.length > 0) {
          if (this.loadingContainer) {
            this.loadingContainer.remove();
          }

          this.renderProducts(data.products);
        } else {
          this.querySelector('slider-component').innerHTML = '';
          this.style.display = 'none';
        }
      })
      .catch((e) => {
        console.error('Error fetching recommendations:', e);
        this.style.display = 'none';
      });
  }

  renderProducts(products) {
    if (this.loadingContainer) {
      this.loadingContainer.remove();
    }

    const sliderContainer = this.querySelector('slider-component');

    if (!sliderContainer) {
      // Create the slider component structure dynamically if it doesn't exist
      const sectionId = 'recommended-products';
      const sliderMarkup = `
                  <div class="loading__spinner hidden">
                          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                  </div>
                  <slider-component class="slider-mobile-gutter slider-component-desktop scroll-trigger animate--slide-in slider-component-full-width">
                  <ul
                    id="Slider-${sectionId}"
                    class="grid product-grid contains-card contains-card--product contains-card--standard grid--2-col slider slider--desktop slider--tablet grid--peek"
                    role="list"
                    aria-label="${this.getTranslation('general.slider.name')}"
                  >
                    ${products
                      .map((product, index) => this.createProductCardMarkup(product, index))
                      .join('')}
                  </ul>
                  ${this.createSliderButtonsMarkup(sectionId, products.length)}
                </slider-component>
              `;

      this.innerHTML = sliderMarkup;

      // Initialize the slider
      this.initializeSlider();
    } else {
      // If slider exists, update the products in the list
      const productList = sliderContainer.querySelector('ul.product-grid');
      if (productList) {
        productList.innerHTML = products
          .map((product, index) => this.createProductCardMarkup(product, index))
          .join('');
        this.initializeSlider();
      }
    }
  }

  createProductCardMarkup(product, index) {
    const sectionId = 'recommended-products';
    const money = this.formatMoney(product.price);
    const compareAtPrice = product.compare_at_price
      ? this.formatMoney(product.compare_at_price)
      : '';

    const imageUrl = product.featured_image?.includes('//')
      ? product.featured_image.replace(/^\/\//, 'https://')
      : product.featured_image;

    return `
                  <li
                    id="Slide-${sectionId}-${index + 1}"
                    class="grid__item slider__slide scroll-trigger animate--slide-in"
                    data-cascade
                    style="--animation-order: ${index + 1};"
                  >
                    <link href="//paddywax.com/cdn/shop/t/104/assets/component-rating.css?v=179577762467860590411744627695" rel="stylesheet" type="text/css" media="all">
                    <link href="//paddywax.com/cdn/shop/t/104/assets/component-volume-pricing.css?v=56284703641257077881744627695" rel="stylesheet" type="text/css" media="all">

                    <div class="recommendation-card-wrapper card-wrapper product-card-wrapper underline-links-hover">
                      <div class="card card--standard card--media" style="--ratio-percent: 100%;">
                        <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;">
                          <div class="card__media">
                            <div class="media media--transparent media--hover-effect">
                              <img
                                srcset="${imageUrl}?v=${Date.now()}&width=165 165w,
                                        ${imageUrl}?v=${Date.now()}&width=360 360w,
                                        ${imageUrl}?v=${Date.now()}&width=533 533w,
                                        ${imageUrl}?v=${Date.now()}&width=720 720w,
                                        ${imageUrl}?v=${Date.now()}&width=940 940w,
                                        ${imageUrl}?v=${Date.now()}&width=1066 1066w,
                                        ${imageUrl}?v=${Date.now()} 2048w"
                                src="${imageUrl}?v=${Date.now()}&width=533"
                                sizes="(min-width: 1500px) 342px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                                alt="${product.title}"
                                class="motion-reduce"
                                loading="lazy"
                                width="2048"
                                height="2048">
                            </div>
                          </div>

                          <div class="card__content">
                            <div class="card__information">
                              <h3 class="card__heading">
                                <a href="${product.url}" id="StandardCardNoMediaLink-${sectionId}-${
      product.id
    }" class="full-unstyled-link" aria-labelledby="StandardCardNoMediaLink-${sectionId}-${
      product.id
    } NoMediaStandardBadge-${sectionId}-${product.id}">
                                  ${product.title}
                                </a>
                              </h3>
                            </div>
                            <div class="card__badge bottom left"></div>
                          </div>
                        </div>

                        <div class="card__content">
                          <div class="card__information">
                            <h3 class="card__heading h3" id="title-${sectionId}-${product.id}">
                              <a href="${product.url}" id="CardLink-${sectionId}-${
      product.id
    }" class="full-unstyled-link" aria-labelledby="CardLink-${sectionId}-${
      product.id
    } Badge-${sectionId}-${product.id}">
                                ${product.title}
                                <br>
                              </a>
                            </h3>
                            <div class="card-information">
                              <span class="caption-large light"></span>
                              <div class="price-badge__container">
                                <div class="price">
                                  <div class="price__container">
                                    <div class="price__regular">
                                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                      <span class="price-item price-item--regular">
                                        ${money}
                                      </span>
                                    </div>

                                    <div class="price__sale">
                                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                      <span>
                                        <s class="price-item price-item--regular">
                                          ${compareAtPrice}
                                        </s>
                                      </span>
                                      <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                      <span class="price-item price-item--sale price-item--last">
                                        ${money}
                                      </span>
                                    </div>

                                    <small class="unit-price caption hidden">
                                      <span class="visually-hidden">Unit price</span>
                                      <span class="price-item price-item--last">
                                        <span></span>
                                        <span aria-hidden="true">/</span>
                                        <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                        <span></span>
                                      </span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="quick-add no-js-hidden">
                            <product-form data-section-id="${sectionId}">
                              <form method="post" action="/cart/add" id="quick-add-${sectionId}${
      product.id
    }" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                                <input type="hidden" name="form_type" value="product">
                                <input type="hidden" name="utf8" value="✓">
                                <input type="hidden" name="id" value="${
                                  product.variants[0].id
                                }" class="product-variant-id">

                                <button id="quick-add-${sectionId}${
      product.id
    }-submit" type="submit" name="add" class="quick-add__submit uppercase button button--full-width button--primary" aria-haspopup="dialog" aria-labelledby="quick-add-${sectionId}${
      product.id
    }-submit title-${sectionId}-${product.id}" aria-live="polite" data-sold-out-message="true">
                                  <span>Add to cart</span>
                                  <span class="sold-out-message hidden">
                                    Sold out
                                  </span>

                                  <div class="loading__spinner hidden">
                                    <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                    </svg>
                                  </div>
                                </button>

                                <input type="hidden" name="product-id" value="${product.id}">
                                <input type="hidden" name="section-id" value="${sectionId}">
                              </form>
                            </product-form>
                          </div>
                          <div class="card__badge bottom left"></div>
                        </div>
                      </div>
                    </div>
                  </li>
                `;
  }

  createSliderButtonsMarkup(sectionId, totalSlides) {
    return `
                    <div class="slider-buttons no-js-hidden">
                      <button
                        type="button"
                        class="slider-button slider-button--prev"
                        name="previous"
                        aria-label="${this.getTranslation('general.slider.previous_slide')}"
                        aria-controls="Slider-${sectionId}"
                      >
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/>
                        </svg>
                      </button>

                      <button
                        type="button"
                        class="slider-button slider-button--next"
                        name="next"
                        aria-label="${this.getTranslation('general.slider.next_slide')}"
                        aria-controls="Slider-${sectionId}"
                      >
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/>
                        </svg>
                      </button>
                    </div>
                  `;
  }

  initializeSlider() {
    const sliderCounter = this.querySelector('.slider-counter--current');
    if (sliderCounter) {
      sliderCounter.textContent = '1';
    }
  }

  // Utility methods
  formatMoney(cents) {
    if (typeof cents !== 'number') {
      cents = parseInt(cents, 10) || 0;
    }
    const formatted = (cents / 100).toFixed(2);

    return '$' + formatted;
  }

  getTranslation(key) {
    const translations = {
      'general.slider.name': 'Slider',
      'general.slider.previous_slide': 'Previous slide',
      'general.slider.next_slide': 'Next slide',
      'general.slider.of': 'of',
    };

    return translations[key] || key;
  }
}

customElements.define('auto-recommendations', AutoRecommendations);
